import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import EmptyState from '../../../components/EmptyState';
import ProgressSpinner from '../../../components/ProgressSpinner';
import InfiniteScrollZone from '../../../components/InfiniteScrollZone';
import DocumentItem from './DocumentItem';
import { isVerifyClientDataToggleEnabled } from '../../toggles/verifyClientDataToggle';
import styles from './DocumentList.m.sass';
var DocumentList = function DocumentList(_ref) {
  var documents = _ref.documents,
    documentStore = _ref.documentStore,
    scrollProvider = _ref.scrollProvider,
    jobId = _ref.jobId,
    useAccessDate = _ref.useAccessDate,
    _ref$emptyTitle = _ref.emptyTitle,
    emptyTitle = _ref$emptyTitle === void 0 ? 'Documents' : _ref$emptyTitle,
    _ref$emptyText = _ref.emptyText,
    emptyText = _ref$emptyText === void 0 ? 'You have not uploaded any documents yet.' : _ref$emptyText,
    _ref$onDocumentSelect = _ref.onDocumentSelectedChange,
    onDocumentSelectedChange = _ref$onDocumentSelect === void 0 ? null : _ref$onDocumentSelect;
  function maybeFilterUnverifiedDocuments(document) {
    if (isVerifyClientDataToggleEnabled()) {
      var _document$latestVersi, _document$latestVersi2;
      var state = document === null || document === void 0 ? void 0 : (_document$latestVersi = document.latestVersion) === null || _document$latestVersi === void 0 ? void 0 : (_document$latestVersi2 = _document$latestVersi.files[0]) === null || _document$latestVersi2 === void 0 ? void 0 : _document$latestVersi2.state;
      return !document.archived && (document.isAuthor || ['Downloadable', 'Purged', 'Failed'].includes(state));
    }
    return !document.archived;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, documents.length === 0 ? /*#__PURE__*/React.createElement(EmptyState, {
    title: emptyTitle
  }, emptyText) : documents.filter(maybeFilterUnverifiedDocuments).map(function (d) {
    return /*#__PURE__*/React.createElement(DocumentItem, {
      key: d.id,
      onSelectedChange: onDocumentSelectedChange,
      document: d,
      documentStore: documentStore,
      jobId: jobId,
      useAccessDate: useAccessDate
    });
  }), scrollProvider && /*#__PURE__*/React.createElement(InfiniteScrollZone, {
    scrollProvider: scrollProvider
  }, function (_ref2) {
    var isDone = _ref2.isDone,
      active = _ref2.active;
    return !isDone && /*#__PURE__*/React.createElement(Loading, null);
  }));
};
var Loading = function Loading() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.loading
  }, /*#__PURE__*/React.createElement(ProgressSpinner, {
    thickness: 3,
    size: 36,
    blue: true
  }));
};
export default observer(DocumentList);
//# sourceMappingURL=index.js.map
